import React, {useCallback} from 'react';

import {TREE_NAMES, TreeSkeleton, updateHiddenFeatures} from 'src/components/features-section';
import {Skeleton} from 'src/components/skeleton';

import CheckBoxTree from '@pb/kit-component-checkbox-tree';
import Group from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

import type {ChangeTreeType} from '@pb/kit-component-checkbox-tree';
import type {TreeStructure} from '@pb/kit-component-tree-v2';


type Props = {
    pluginsAppsTree: TreeStructure | null,
    loading: boolean,
    platformFeatures: Array<string>,
    onChange: (platformFeatures: Array<string>) => void,
    layoutLevel?: number,
};

export const PluginsAppsSection: React.FC<Props> = props => {
    const {loading, pluginsAppsTree, platformFeatures, onChange, layoutLevel} = props;

    const onChangeTree = useCallback((changeTreeType: ChangeTreeType) => {
        onChange(updateHiddenFeatures(platformFeatures, changeTreeType));
    }, [platformFeatures, onChange]);

    return (
        <Skeleton view={<TreeSkeleton rows={3}/>} shown={loading}>
            <Group direction="v" gap="m">
                <Label>Plugins and Apps</Label>
                {pluginsAppsTree ? (
                    <CheckBoxTree
                        data={pluginsAppsTree}
                        onChange={onChangeTree}
                        name={TREE_NAMES.PLUGINS_AND_APPS}
                        checkedIdsList={platformFeatures}
                        layoutLevel={layoutLevel}
                    />
                ) : null}
            </Group>
        </Skeleton>
    );
};
